namespace TabAurous.OMS {
    export interface ReasonStatusRow {
        ReasonStatusId?: number;
        Type?: string;
        TypeId?: number;
        TypeName?: string;
        TypeDescription?: string;
        Notification?: string;
        IsDefault?: boolean;
        NotifyCustomer?: boolean;
        UpdateECommerce?: boolean;
    }

    export namespace ReasonStatusRow {
        export const idProperty = 'ReasonStatusId';
        export const nameProperty = 'TypeDescription';
        export const localTextPrefix = 'OMS.ReasonStatus';
        export const lookupKey = 'OMS.ReasonStatus';

        export function getLookup(): Q.Lookup<ReasonStatusRow> {
            return Q.getLookup<ReasonStatusRow>('OMS.ReasonStatus');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ReasonStatusId = "ReasonStatusId",
            Type = "Type",
            TypeId = "TypeId",
            TypeName = "TypeName",
            TypeDescription = "TypeDescription",
            Notification = "Notification",
            IsDefault = "IsDefault",
            NotifyCustomer = "NotifyCustomer",
            UpdateECommerce = "UpdateECommerce"
        }
    }
}
